import { render, staticRenderFns } from "./CaIndex.vue?vue&type=template&id=7b2d83e7&scoped=true&"
import script from "./CaIndex.vue?vue&type=script&lang=js&"
export * from "./CaIndex.vue?vue&type=script&lang=js&"
import style0 from "./CaIndex.vue?vue&type=style&index=0&id=7b2d83e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2d83e7",
  null
  
)

export default component.exports